import axiosInstance from "../../axiosInstance.js";
import { baseUrl } from "../../endpoints.js";
import { configReq } from "../../../lib/functions.js";

/** Keeps the existing DELETE request and response contract. */
export function deleteRequest(removeApi, id, token) {
  return axiosInstance.delete(`${baseUrl}/${removeApi}?id=${id}`, configReq(token));
}
